import { Box, Typography, capitalize } from "@mui/material"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { FC } from "react"

import { useGetRoles } from "../hooks"
import { UserStatus } from "../types"

import { FilterChip } from "@/components/common/Filters"
import type { UserQueryableFields } from "@/graphql/codegen/graphql"

const UsersFilterChips: FC = () => {
  const { isActive, roleIds } = useSearch({
    from: "/app/admin/system-admin/_layout/users",
    strict: true,
  })
  const navigate = useNavigate({ from: "/app/admin/system-admin/users" })

  const { roles } = useGetRoles({})

  if (isActive === undefined) {
    return null
  }

  const status = isActive ? UserStatus.Active : UserStatus.Inactive
  const label = capitalize(status.toLowerCase())

  const handleClearFilter = (name: keyof UserQueryableFields, value?: unknown) => {
    let searchReducer: (prev: Record<string, any>) => Record<string, any>

    if (name === "isActive") {
      searchReducer = (prev: Record<string, any>) => ({
        ...prev,
        [name]: undefined,
      })
    } else {
      searchReducer = (prev: Record<string, any>) => ({
        ...prev,
        [name]: (prev[name] as string[]).filter((id) => id !== value),
      })
    }

    navigate({
      search: searchReducer,
      replace: true,
    })
  }

  return (
    <Box data-testid='User-filter-chips' display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      <FilterChip key={`isActive-${isActive}`} label={label} onDelete={() => handleClearFilter("isActive")} />

      {roleIds?.map((roleId) => {
        const role = roles?.find((r) => r.roleId === roleId)
        return (
          <FilterChip
            key={`role-${roleId}`}
            label={role?.name ?? ""}
            onDelete={() => handleClearFilter("roleIds", roleId)}
          />
        )
      })}
    </Box>
  )
}

export default UsersFilterChips
